<template>
  <div class="modalFormWrap formStyle">
    <div :class="{'bdTop mgTop': i!=0}" v-for="(m, i) in newInfo" :key="i">
      <p class="textRight pdBtm" v-if="!m.id && i>0"><span class="removeBtn" @click="remove(i)"><Icon type="ios-trash-outline" size="18" />删除</span></p>
      <Form :ref="`newForm${i}`" :model="m" :rules="rules">
        <Row :gutter="30">
          <Col span="12">
            <FormItem prop="mediaName" label="媒体名称">
              <Input type="text" v-model="m.mediaName"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="countryId" label="媒体国家">
              <Select v-model="m.countryId" placeholder="" filterable>
                <Option v-for="c in countryList" :value="c.id" :key="c.id">{{c.name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="year" label="报道时间">
              <DatePicker type="year" :clearable="false" :editable="false" v-model="m.year" @on-change="(val, type)=>{setYear(val, type, i)}"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="title" label="报道标题">
              <Input type="text" v-model="m.title"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem prop="url" label="相关链接或报道证明（必选一项）">
              <Input type="text" v-model="m.url"></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <div>
              <Upload
                :ref="`imgBtn${i}`"
                :action="imgApi"
                :headers="{Authorization: token}"
                name="picture"
                :data="{applyType: 'CERTIFICATE', 'fileIndex': i}"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :before-upload="handleBeforeUpload" 
                :on-format-error="handleFormatError"
                :on-error="handleError"
                :on-exceeded-size="handleSize"
                :on-progress="handleProgress"
                :max-size="5120"
                accept="image/jpg, image/png, image/jpeg">
                <Tooltip theme="light" max-width="200" placement="bottom-start">
                  <Button class="defaultBtn size12" shape="circle">上传报道证明图片</Button>
                  <div slot="content" class="size12">
                    <p>可上传格式：JPG，PNG。</p>
                  </div>
                </Tooltip>
              </Upload>
            </div>
            <div class="imgWrap" >
              <template v-if="m.certificate">
                <img v-if="m.certificate" class="img" :src="getImageUrl(m.certificate, 'avatar')" alt="">
                <div class="imgMask">
                  <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(m.certificate))" />
                  <Icon type="ios-close-circle-outline" class="delImg" @click="removeImg(i)"/>
                </div>
              </template>
              <template v-else>
                <Progress v-if="fileUpload.showProgress" :percent="fileUpload.percentage" hide-info></Progress>
              </template>
              <Modal v-model="showLargePic"
                title="查看图片" 
                :footer-hide="true"
                :styles="{top: '50px'}"
                width=640>
                <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
              </Modal>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btnWrap">
      <p class="textLeft pdBtm"><span class="addBtn" @click="addMedia">添加其它媒体曝光</span></p>
      <Button class="defaultBtn formBtn" shape="circle" @click="submitAll">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </div>
</template>

<script>
import personalService from '@/api/personal'
import centerService from '@/api/center'
import { baseUrl } from '@/config/env'
export default {
  props: ['info'],
  data(){
    return{
      imgApi: `${baseUrl}picture/upload`,
      token: this.$store.getters.token,
      countryList: [],
      newInfo: [{countryId: 1}],
      fileUpload: {showProgress: false, percentage: 0},
      rules: {
        mediaName: [{required: true, message: "请输入媒体名称", trigger: 'blur,change'}],
        year: [{required: true, message: "请选择报道时间", trigger: 'blur,change', pattern: /.+/}],
        title: [{required: true, message: "请输入报道标题", trigger: 'blur,change'}],
      },
      submitting: false,
      showLargePic: false,
      largePicPath: ''
    }
  },
  mounted(){
    // this.newInfo = Object.assign({}, this.info)
    // this.newInfo = Object.assign([], this.info)
    if(this.info.length>0){
      this.newInfo = []
    }
    for(let i=0,l=this.info.length;i<l;i++){
      // this.newInfo[i] = Object.assign({}, this.info[i])
      this.newInfo.push(Object.assign({}, this.info[i]))
    }
    this.getCountryList()
  },
  methods:{
    // 上传图片成功
    handleSuccess(res) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        this.newInfo[data.fileIndex].certificate = data.path
        this.fileUpload.showProgress = false
        this.fileUpload.percentage = 0
        this.$forceUpdate()
      }
    },
    handleBeforeUpload(file) {
      let check = true
      if(file.size == 0){
        check = false
      }
      this.fileUpload.showProgress = true
      return check;
    },
    handleProgress(event){
      this.fileUpload.percentage = event.percent
    },
    // 文件超出最大值5M
    handleSize(){
      this.$Message.info('文件超过最大值5M，请重新选择！')
    },
    // 文件格式错误提示
    handleFormatError (file) {
      this.$Message.error(`文件${file.name}格式错误`)
    },
    // 错误提示
    handleError(error){
      this.$Message.error('服务器错误' + error)
    },
    getCountryList(){
      centerService.getAllCountry()
      .then(res => {
        if(res.errorNo==0){
          this.countryList = res.data
        }else{
          this.$Message.error(res.errorMessage)
        }
      }).catch( () => {
        // this.$Message.error(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    // 添加
    addMedia(){
      this.newInfo.push({countryId: 1})
    },
    // 移除
    remove(i){
      this.newInfo.splice(i, 1)
    },
    // 提交信息
    submit(){
      let k = 0, l = this.newInfo.length
      for(let i=0;i<l;i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            this.submitting = true
            let condition = Object.assign({}, this.newInfo[i])
            if((typeof condition.year) != 'string'){
              let dt = condition.year
              dt.setHours(dt.getHours() + 8)
              condition.year = dt.getFullYear() + ''
            }
            // console.log(condition.year)
            personalService.saveMedia(condition)
            .then(res => {
              if(res.errorNo==0){
                k++
                this.$parent.$parent.getMediaList()
              }else{
                this.$Message.error(res.errorMessage)
              }
              this.submitting = false
            }).catch(err => {
              this.submitting = false
              // this.$Message.error(err.message)
              console.log(err.message)
              this.$Message.error('连接服务器失败，请稍后再试')
            })
          }else{
            this.$Message.error('信息未填写完整')
          }
        })
      }
      let _this = this
      let timer = setInterval(function(){
        if(k==l){
          _this.skip()
          clearInterval(timer)
        }
      }, 500)
      setTimeout(function(){
        clearInterval(timer)
      }, 10000)
    },
    // 提交全部信息
    submitAll(){
      let k = 0, l = this.newInfo.length
      for(let i=0; i<l; i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            // let condition = Object.assign({}, this.newInfo[i]) 
            if((typeof this.newInfo[i].year) != 'string'){
              let dt = this.newInfo[i].year
              dt.setHours(dt.getHours() + 8)
              this.newInfo[i].year = dt.getFullYear() + ''
            }
            this.newInfo[i].country = this.getCountryName(this.newInfo[i].countryId)

            k++
          }else{
            // this.$Message.error('信息未填写完整')
          }
        })
      }
      // console.log(k+'_'+l)
      if(k != l){
        this.$Message.error('信息未填写完整')
        return
      }
      this.submitting = true
      personalService.saveAllMedia(this.newInfo)
      .then(res => {
        if(res.errorNo==0){
          this.$parent.$parent.getMediaList()
          this.skip()
        }else{
          this.$Message.error(res.errorMessage)
        }
        this.submitting = false
      }).catch(err => {
        this.submitting = false
        // this.$Message.error(err.message)
        console.log(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    getCountryName(countryId){
      for(let i=0; i<this.countryList.length; i++){
        if(this.countryList[i].id == countryId){
          return this.countryList[i].name
        }
      }
    },
    setYear(val, type, i){
      this.newInfo[i].year = val
      this.$refs[`newForm${i}`][0].validateField('year')
    },
    // 查看大图
    openImg(path){
      // window.open(path, '_blank')
      this.showLargePic = true
      this.largePicPath = path
    },
    // 删除图片
    removeImg(i){
      this.newInfo[i].certificate = null
    },
    skip(){
      this.$emit('Skip', {key: 'mediaInfo'})
    }
  }
}
</script>